(function () {
  'use strict';

  const cfg = window.themeSettings || {};

  const $ = (s, ctx = document) => ctx.querySelector(s);
  const $$ = (s, ctx = document) => [...ctx.querySelectorAll(s)];
  const on = (el, ev, fn) => el && el.addEventListener(ev, fn);

  function formatMoney(cents, format) {
    const fmt = format || cfg.moneyFormat || '£{{amount}}';
    const n = Number(cents);
    const safe = isFinite(n) ? n : 0;
    const amount = (safe / 100).toFixed(2);
    return fmt.replace('{{amount}}', amount).replace('{{amount_no_decimals}}', Math.floor(safe / 100));
  }

  function initHeaderScroll() {
    const header = $('#siteHeader');
    if (!header) return;

    let lastY = window.scrollY;

    function update() {
      const y = window.scrollY;
      const headerH = header.offsetHeight;

      if (y <= headerH) {
        
        header.classList.remove('header--hidden');
      } else if (y > lastY) {
        
        header.classList.add('header--hidden');
      } else if (y < lastY) {
        
        header.classList.remove('header--hidden');
      }

      header.classList.toggle('scrolled', y > 10);
      lastY = y;
    }

    on(window, 'scroll', update, { passive: true });

    function setHeaderHeight() {
      document.documentElement.style.setProperty(
        '--header-height',
        header.offsetHeight + 'px'
      );
    }
    setHeaderHeight();
    on(window, 'resize', setHeaderHeight);
  }

  let drawerHistory = [];

  function openMobDrawer() {
    const drawer = $('#mobDrawer');
    const backdrop = $('#mobBackdrop');
    const toggle = $('#mobToggle');
    if (!drawer) return;
    const header = $('#siteHeader');
    if (header) header.classList.remove('search-open');
    drawer.classList.add('open');
    backdrop.classList.add('open');
    document.body.style.overflow = 'hidden';
    if (toggle) toggle.setAttribute('aria-expanded', 'true');
    drawer.setAttribute('aria-hidden', 'false');
    
    const l1 = $('#drawer-l1');
    if (l1) l1.classList.add('is-active');
    drawerHistory = [];
  }

  function closeMobDrawer() {
    const drawer = $('#mobDrawer');
    const backdrop = $('#mobBackdrop');
    const toggle = $('#mobToggle');
    if (!drawer) return;
    drawer.classList.remove('open');
    backdrop.classList.remove('open');
    document.body.style.overflow = '';
    if (toggle) toggle.setAttribute('aria-expanded', 'false');
    drawer.setAttribute('aria-hidden', 'true');
    
    $$('.drawer-panel').forEach(p => {
      p.classList.remove('is-active', 'is-prev');
    });
    const l1 = $('#drawer-l1');
    if (l1) l1.classList.add('is-active');
    drawerHistory = [];
  }

  function openDrawerPanel(id) {
    const target = $('#' + id);
    if (!target) return;
    const active = $('.drawer-panel.is-active');
    if (active) {
      active.classList.remove('is-active');
      active.classList.add('is-prev');
      drawerHistory.push(active.id);
    }
    target.classList.add('is-active');
    target.scrollTop = 0;
  }

  function drawerBack() {
    const active = $('.drawer-panel.is-active');
    const prevId = drawerHistory.pop();
    if (!prevId) return;
    const prev = $('#' + prevId);
    if (active) active.classList.remove('is-active');
    if (prev) {
      prev.classList.remove('is-prev');
      prev.classList.add('is-active');
    }
  }

  window.openMobDrawer = openMobDrawer;
  window.closeMobDrawer = closeMobDrawer;
  window.openDrawerPanel = openDrawerPanel;
  window.drawerBack = drawerBack;

  function initMobileDrawer() {
    on($('#mobToggle'), 'click', openMobDrawer);
    on($('#mobBackdrop'), 'click', closeMobDrawer);
    on(document, 'keydown', e => {
      if (e.key === 'Escape') closeMobDrawer();
    });

    on($('#mobDrawer'), 'click', e => {
      const openBtn = e.target.closest('[data-open-panel]');
      if (openBtn) { openDrawerPanel(openBtn.dataset.openPanel); return; }

      if (e.target.closest('[data-drawer-back]')) { drawerBack(); return; }

      if (e.target.closest('[data-close-drawer]')) { closeMobDrawer(); }
    });
  }

  function openMobSearch() {
    const header = $('#siteHeader');
    if (!header) return;
    closeMobDrawer();
    header.classList.add('search-open');
    const backdrop = $('#mobBackdrop');
    if (backdrop) backdrop.classList.add('open');
    document.body.style.overflow = 'hidden';
    const toggle = $('#mobSearchToggle');
    if (toggle) toggle.setAttribute('aria-expanded', 'true');
    const input = $('#SearchInput');
    if (input) setTimeout(() => input.focus(), 60);
  }

  function closeMobSearch() {
    const header = $('#siteHeader');
    if (!header || !header.classList.contains('search-open')) return;
    header.classList.remove('search-open');
    const drawer = $('#mobDrawer');
    if (!drawer || !drawer.classList.contains('open')) {
      const backdrop = $('#mobBackdrop');
      if (backdrop) backdrop.classList.remove('open');
      document.body.style.overflow = '';
    }
    const toggle = $('#mobSearchToggle');
    if (toggle) toggle.setAttribute('aria-expanded', 'false');
    const results = $('#predictive-search-results');
    if (results) results.classList.remove('is-open');
  }

  function initMobileSearch() {
    const toggle = $('#mobSearchToggle');
    if (!toggle) return;
    on(toggle, 'click', () => {
      $('#siteHeader').classList.contains('search-open') ? closeMobSearch() : openMobSearch();
    });
    on($('#mobBackdrop'), 'click', closeMobSearch);
    on(document, 'keydown', e => { if (e.key === 'Escape') closeMobSearch(); });
  }

  function initAnnouncementBar() {
    const bar = $('#announcementBar');
    if (!bar) return;

    const closeBtn = $('#announcementClose');
    if (closeBtn) {
      on(closeBtn, 'click', () => {
        bar.style.display = 'none';
        sessionStorage.setItem('announcement_dismissed', '1');
      });
      if (sessionStorage.getItem('announcement_dismissed') === '1') {
        bar.style.display = 'none';
        return;
      }
    }

    const track = $('#announcementTrack');
    if (!track) return;
    const msgs = $$('.announcement-bar__message', track);
    if (msgs.length <= 1) return;

    const autoplay = bar.dataset.autoplay === 'true';
    if (!autoplay) return;
    const speed = parseInt(bar.dataset.speed) || 5000;
    let idx = 0;

    function rotate() {
      msgs[idx].style.display = 'none';
      idx = (idx + 1) % msgs.length;
      msgs[idx].style.display = 'flex';
    }

    setInterval(rotate, speed);
  }

  function initTrustBar() {
    const inner = $('#trustInner');
    if (!inner) return;

    const origItems = $$('.trust-item', inner);
    if (origItems.length <= 1) return;

    const origCount = origItems.length;
    let current = 0;
    let timer;
    let transitioning = false;

    origItems.forEach(item => inner.appendChild(item.cloneNode(true)));

    function pv() {
      return window.innerWidth < 600 ? 1 : window.innerWidth < 900 ? 2 : 3;
    }

    function goTo(index, animate) {
      inner.style.transition = animate ? 'transform 0.55s cubic-bezier(.22,.1,.25,1)' : 'none';
      inner.style.transform = `translateX(-${(100 / pv()) * index}%)`;
    }

    function setPerView() {
      inner.style.setProperty('--trust-per-view', pv());
      goTo(current, false);
    }

    function slide() {
      if (transitioning) return;
      transitioning = true;
      goTo(++current, true);
    }

    on(inner, 'transitionend', () => {
      transitioning = false;
      if (current >= origCount) {
        current = 0;
        goTo(0, false);
      }
    });

    function autoplay() {
      if (inner.dataset.autoplay !== 'true') return;
      const speed = parseInt(inner.dataset.speed) || 3000;
      timer = setInterval(slide, speed);
    }

    setPerView();
    on(window, 'resize', setPerView);
    on(inner.parentElement, 'mouseenter', () => clearInterval(timer));
    on(inner.parentElement, 'mouseleave', autoplay);
    autoplay();
  }

  function initBrandSlider(root) {
    (root || document).querySelectorAll('.brand-slider').forEach(setupBrandSlider);
  }

  function setupBrandSlider(el) {
    if (el.dataset.bsReady === '1') return;
    const track = el.querySelector('.brand-slider__track');
    if (!track) return;
    el.dataset.bsReady = '1';

    const prevBtn = el.querySelector('.brand-slider__arrow--prev');
    const nextBtn = el.querySelector('.brand-slider__arrow--next');
    const orig = Array.from(track.children);
    const origCount = orig.length;
    const dwell = (parseFloat(el.dataset.dwell) || 4) * 1000;
    const autoplay = el.dataset.autoplay === 'true';
    const pauseHover = el.dataset.pauseHover === 'true';

    const perDesktop = parseInt(el.dataset.perDesktop) || 6;
    const perTablet = parseInt(el.dataset.perTablet) || 4;
    const perMobile = parseInt(el.dataset.perMobile) || 2;
    const perView = () => {
      const w = window.innerWidth;
      if (w <= 600) return perMobile;
      if (w <= 900) return perTablet;
      return perDesktop;
    };

    // Not enough logos to ever scroll — leave static.
    if (origCount <= Math.max(perDesktop, perTablet, perMobile)) {
      if (prevBtn) prevBtn.style.display = 'none';
      if (nextBtn) nextBtn.style.display = 'none';
      return;
    }

    // Clone the full set before AND after the originals so there is always a logo
    // to slide into in either direction; the real logos sit at [origCount .. 2*origCount).
    const before = orig.map(node => node.cloneNode(true));
    const after = orig.map(node => node.cloneNode(true));
    before.reverse().forEach(node => track.insertBefore(node, track.firstChild));
    after.forEach(node => track.appendChild(node));

    let current = origCount;
    let timer = null;

    function apply(animate) {
      if (!animate) track.style.transition = 'none';
      track.style.transform = 'translateX(-' + (100 / perView()) * current + '%)';
      if (!animate) {
        void track.offsetWidth; // flush, then restore the transition
        track.style.transition = '';
      }
    }

    function goTo(i) {
      current = i;
      apply(true);
    }

    on(track, 'transitionend', e => {
      if (e.target !== track || e.propertyName !== 'transform') return;
      if (current >= origCount * 2) {
        current -= origCount;
        apply(false);
      } else if (current < origCount) {
        current += origCount;
        apply(false);
      }
    });

    function start() {
      if (autoplay && !timer) timer = setInterval(() => goTo(current + 1), dwell);
    }
    function stop() {
      clearInterval(timer);
      timer = null;
    }

    on(prevBtn, 'click', () => { stop(); goTo(current - 1); start(); });
    on(nextBtn, 'click', () => { stop(); goTo(current + 1); start(); });

    if (pauseHover) {
      on(el, 'mouseenter', stop);
      on(el, 'mouseleave', start);
    }

    let resizeTimer;
    on(window, 'resize', () => {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(() => {
        current = origCount + (((current - origCount) % origCount) + origCount) % origCount;
        apply(false);
      }, 150);
    });

    el._bs = { start, stop };
    apply(false);
    if (!window.matchMedia || !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      start();
    }
  }

  const hcReduceMotion = window.matchMedia
    ? window.matchMedia('(prefers-reduced-motion: reduce)').matches
    : false;

  function initHeroCarousel(root) {
    const scope = root && root.querySelectorAll ? root : document;
    $$('.hero-carousel', scope).forEach(setupHeroCarousel);
    if (root && root.matches && root.matches('.hero-carousel')) setupHeroCarousel(root);
  }

  function setupHeroCarousel(section) {
    if (section.dataset.hcReady === '1') return;
    section.dataset.hcReady = '1';

    const track = $('[data-hc-track]', section);
    if (!track) return;
    const slides = $$('.hc-slide', track);
    if (slides.length === 0) return;

    const mode = section.dataset.transition === 'fade' ? 'fade' : 'slide';
    const dotsEl = $('[data-hc-dots]', section);
    const design = !!(window.Shopify && window.Shopify.designMode);
    let current = 0;
    let timer = null;

    function render() {
      slides.forEach((s, i) => {
        s.classList.toggle('is-active', i === current);
        s.setAttribute('aria-hidden', i === current ? 'false' : 'true');
      });
      if (mode === 'slide') track.style.transform = `translateX(-${100 * current}%)`;
      if (dotsEl) {
        $$('.hc-dot', dotsEl).forEach((d, i) => d.classList.toggle('active', i === current));
      }
    }

    function goTo(index) {
      current = ((index % slides.length) + slides.length) % slides.length;
      render();
    }
    const next = () => goTo(current + 1);
    const prev = () => goTo(current - 1);

    function stop() {
      clearInterval(timer);
      timer = null;
    }

    function start() {
      stop();
      if (hcReduceMotion || design) return;
      if (section.dataset.autoplay !== 'true' || slides.length < 2) return;
      const speed = parseInt(section.dataset.speed, 10) || 5000;
      timer = setInterval(next, speed);
    }

    if (dotsEl && slides.length > 1) {
      slides.forEach((_, i) => {
        const b = document.createElement('button');
        b.type = 'button';
        b.className = 'hc-dot' + (i === 0 ? ' active' : '');
        b.setAttribute('aria-label', `Slide ${i + 1}`);
        on(b, 'click', () => { stop(); goTo(i); start(); });
        dotsEl.appendChild(b);
      });
    }

    on($('[data-hc-prev]', section), 'click', () => { stop(); prev(); start(); });
    on($('[data-hc-next]', section), 'click', () => { stop(); next(); start(); });
    on(section, 'mouseenter', stop);
    on(section, 'mouseleave', start);
    on(section, 'focusin', stop);
    on(section, 'focusout', start);
    on(section, 'keydown', e => {
      if (e.key === 'ArrowLeft') { stop(); prev(); start(); }
      if (e.key === 'ArrowRight') { stop(); next(); start(); }
    });
    on(document, 'visibilitychange', () => (document.hidden ? stop() : start()));

    section._hc = {
      stop: stop,
      start: start,
      goTo: goTo,
      indexOfBlock: id => slides.findIndex(s => s.id === 'hc-slide-' + id)
    };

    render();
    start();
  }

  function hcInEvent(e) {
    return e.target && e.target.querySelector && e.target.querySelector('.hero-carousel');
  }

  function initBrandsCarousel() {
    const row = $('#brandsRow');
    if (!row) return;

    const total = parseInt(row.dataset.total) || 0;
    let perView = () => window.innerWidth < 600 ? 2 : window.innerWidth < 900 ? 3 : 6;
    let current = 0;
    let timer;

    const dots = $('#brandsDots');
    const prev = $('#brandsPrev');
    const next = $('#brandsNext');

    function pages() { return Math.ceil(total / perView()); }

    function goTo(page) {
      const pv = perView();
      const maxPage = Math.ceil(total / pv) - 1;
      current = Math.max(0, Math.min(page, maxPage));
      row.style.transition = 'transform 0.45s cubic-bezier(.22,.1,.25,1)';
      row.style.transform = `translateX(-${(100 / pv) * current * pv}%)`;
      renderDots();
    }

    function renderDots() {
      if (!dots) return;
      const p = pages();
      dots.innerHTML = '';
      for (let i = 0; i < p; i++) {
        const d = document.createElement('button');
        d.className = 'carousel-dot' + (i === current ? ' active' : '');
        d.setAttribute('aria-label', `Page ${i + 1}`);
        d.addEventListener('click', () => { clearInterval(timer); goTo(i); startTimer(); });
        dots.appendChild(d);
      }
    }

    function startTimer() {
      clearInterval(timer);
      timer = setInterval(() => goTo((current + 1) % pages()), 4000);
    }

    on(prev, 'click', () => { clearInterval(timer); goTo(current - 1); startTimer(); });
    on(next, 'click', () => { clearInterval(timer); goTo(current + 1); startTimer(); });

    const carousel = $('#brandsCarousel');
    on(carousel, 'mouseenter', () => clearInterval(timer));
    on(carousel, 'mouseleave', startTimer);

    on(window, 'resize', () => { goTo(0); });

    renderDots();
    startTimer();
  }

  function initPredictiveSearch() {
    if (!cfg.enablePredictiveSearch) return;
    const input = $('#SearchInput');
    const results = $('#predictive-search-results');
    if (!input || !results) return;

    let debounceTimer;

    on(input, 'input', () => {
      clearTimeout(debounceTimer);
      const q = input.value.trim();
      if (q.length < 2) {
        results.classList.remove('is-open');
        return;
      }
      debounceTimer = setTimeout(() => {
        fetch(`/search/suggest.json?q=${encodeURIComponent(q)}&resources[type]=product,collection,article&resources[limit]=${cfg.predictiveResultsCount || 5}`)
          .then(r => r.json())
          .then(data => renderPredictive(data, q))
          .catch(() => {});
      }, 220);
    });

    function renderPredictive(data, q) {
      const products = data?.resources?.results?.products || [];
      const collections = data?.resources?.results?.collections || [];

      if (products.length === 0 && collections.length === 0) {
        results.classList.remove('is-open');
        return;
      }

      let html = '';

      if (products.length > 0) {
        html += '<p class="predictive-search__section-title">Products</p>';
        products.forEach(p => {
          html += `<a class="predictive-search__item" href="${p.url}">
            <div class="predictive-search__item-img">
              ${p.featured_image?.url ? `<img src="${p.featured_image.url}&width=84" alt="${p.title}" width="42" height="42" loading="lazy">` : ''}
            </div>
            <div>
              <div class="predictive-search__item-title">${p.title}</div>
              <div class="predictive-search__item-price">${formatMoney(Math.round(parseFloat(p.price) * 100))}</div>
            </div>
          </a>`;
        });
      }

      if (collections.length > 0) {
        html += '<p class="predictive-search__section-title">Collections</p>';
        collections.forEach(c => {
          html += `<a class="predictive-search__item" href="${c.url}">
            <div class="predictive-search__item-img"></div>
            <div><div class="predictive-search__item-title">${c.title}</div></div>
          </a>`;
        });
      }

      html += `<a class="predictive-search__all" href="/search?q=${encodeURIComponent(q)}&type=product">View all results for "${q}"</a>`;

      results.innerHTML = html;
      results.classList.add('is-open');
      input.setAttribute('aria-expanded', 'true');
    }

    on(document, 'click', e => {
      if (!input.contains(e.target) && !results.contains(e.target)) {
        results.classList.remove('is-open');
        input.setAttribute('aria-expanded', 'false');
      }
    });

    on(input, 'keydown', e => {
      if (e.key === 'Escape') {
        results.classList.remove('is-open');
        input.setAttribute('aria-expanded', 'false');
      }
    });
  }

  function updateCartBadge(count) {
    const badge = $('#cartBadge');
    const drawerCount = $('#cartDrawerCount');
    if (badge) {
      badge.textContent = count;
      badge.style.display = count > 0 ? 'flex' : 'none';
    }
    if (drawerCount) drawerCount.textContent = count;
  }

  function refreshCartDrawer() {
    return fetch('/cart.js')
      .then(r => {
        if (!r.ok) throw new Error('Cart error');
        return r.json();
      })
      .then(cart => {
        updateCartBadge(cart.item_count);
        renderCartDrawerItems(cart);
        renderCartPage(cart);
      })
      .catch(() => {});
  }

  // Fetch the live cart once on page load and reflect discount codes / savings.
  // Manual discount codes aren't present on the Liquid `cart` object (Shopify
  // only applies them at checkout), so /cart.js is the sole source on first paint.
  function hydrateCart() {
    const count = parseInt($('#cartDrawerCount')?.textContent || $('#cartBadge')?.textContent || '0', 10);
    if (!count) return;
    fetch('/cart.js')
      .then(r => (r.ok ? r.json() : null))
      .then(cart => {
        if (!cart) return;
        updateCartBadge(cart.item_count);
        renderCartDrawerItems(cart);
        renderCartPage(cart);
      })
      .catch(() => {});
  }

  let lineErrorTimer;

  function insertItemNotice(rowSelector, anchorSelector, noticeClass, key, msg) {
    const row = $(`${rowSelector}[data-key="${key}"]`);
    const anchor = row && row.querySelector(anchorSelector);
    if (!anchor) return;
    const note = document.createElement('div');
    note.className = noticeClass;
    note.setAttribute('role', 'alert');
    note.textContent = msg;
    anchor.after(note);
  }

  function showLineError(key, msg) {
    clearLineErrors();
    if (!msg) return;
    insertItemNotice('.cart-drawer__item', '.cart-drawer__item-footer', 'cart-drawer__item-notice', key, msg);
    insertItemNotice('.cart-page .cart-item', '[data-qty-wrap]', 'cart-item__notice', key, msg);
    lineErrorTimer = setTimeout(clearLineErrors, 6000);
  }

  function clearLineErrors() {
    clearTimeout(lineErrorTimer);
    $$('.cart-drawer__item-notice, .cart-item__notice').forEach(el => el.remove());
  }

  function renderCartDrawerItems(cart) {
    if (!cart || typeof cart.total_price !== 'number' || !Array.isArray(cart.items)) return;
    const itemsEl = $('#cartDrawerItems');
    const subtotalEl = $('#cartSubtotal');
    const footer = $('.cart-drawer__footer');
    const shippingBar = $('#cartShippingBar');
    const discountSection = $('#cartDiscountSection');

    if (subtotalEl) subtotalEl.textContent = formatMoney(cart.total_price);

    if (shippingBar) {
      const threshold = cfg.freeShippingThreshold || 10000;
      const label = $('#cartShippingLabel');
      const fill = $('#cartShippingFill');
      if (cart.total_price >= threshold) {
        shippingBar.classList.add('cart-drawer__shipping-bar--reached');
        if (label) label.innerHTML = cfg.locales?.shippingBarReached || "You have unlocked free delivery!";
      } else {
        shippingBar.classList.remove('cart-drawer__shipping-bar--reached');
        const remaining = formatMoney(threshold - cart.total_price);
        if (label) label.innerHTML = (cfg.locales?.shippingBarProgress || 'Spend [[amount]] more').replace('[[amount]]', `<strong>${remaining}</strong>`);
      }
      const pct = Math.min(100, Math.round(cart.total_price / threshold * 100));
      if (fill) fill.style.width = pct + '%';
    }

    if (!itemsEl) return;

    if (cart.item_count === 0) {
      itemsEl.innerHTML = `
        <div class="cart-drawer__empty">
          <div class="cart-drawer__empty-icon"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M6 2L3 6v14a2 2 0 002 2h14a2 2 0 002-2V6l-3-4zM3 6h18M16 10a4 4 0 01-8 0"/></svg></div>
          <h3>Your cart is empty</h3>
          <a href="/collections/all" class="btn btn-primary">Continue Shopping</a>
        </div>`;
      if (footer) footer.style.display = 'none';
      if (discountSection) discountSection.style.display = 'none';
      renderDrawerDiscount(cart);
      return;
    }

    if (footer) footer.style.display = '';
    if (discountSection) discountSection.style.display = '';

    let html = '';
    cart.items.forEach(item => {
      html += `
        <div class="cart-drawer__item" data-key="${item.key}">
          <a href="${item.url}" tabindex="-1">
            ${item.image ? `<img class="cart-drawer__item-img" src="${item.image}" alt="${item.title}" width="72" height="72" loading="lazy">` : '<div class="cart-drawer__item-img"></div>'}
          </a>
          <div>
            <a class="cart-drawer__item-title" href="${item.url}">${item.product_title}</a>
            ${!item.product_has_only_default_variant && item.variant_title && item.variant_title !== 'Default Title' ? `<p class="cart-drawer__item-variant">${item.variant_title}</p>` : ''}
            <div class="cart-drawer__item-footer">
              <div class="qty-row" data-key="${item.key}">
                <button class="qty-btn" type="button" data-cart-qty-btn="-1" data-key="${item.key}">−</button>
                <input class="qty-val" type="number" value="${item.quantity}" min="1" data-cart-qty-input data-key="${item.key}">
                <button class="qty-btn" type="button" data-cart-qty-btn="1" data-key="${item.key}">+</button>
              </div>
              <div>
                <div class="cart-drawer__item-price">${formatMoney(item.final_line_price)}</div>
                <button class="cart-drawer__item-remove" type="button" data-remove-key="${item.key}">
                  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" width="12" height="12"><polyline points="3 6 5 6 21 6"/><path d="M19 6v14a2 2 0 01-2 2H7a2 2 0 01-2-2V6m3 0V4a1 1 0 011-1h4a1 1 0 011 1v2"/></svg>
                  Remove
                </button>
              </div>
            </div>
          </div>
        </div>`;
    });

    itemsEl.innerHTML = html;

    renderDrawerDiscount(cart);
  }

  const ICON_CHECK = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" width="12" height="12"><polyline points="20 6 9 17 4 12"/></svg>';
  const ICON_CLOSE = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" width="10" height="10"><path d="M18 6L6 18M6 6l12 12"/></svg>';

  function applicableCodes(cart) {
    return (cart && Array.isArray(cart.discount_codes) ? cart.discount_codes : [])
      .filter(dc => dc && dc.applicable);
  }

  function escHtml(s) {
    return String(s).replace(/[&<>"]/g, c => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]));
  }

  function discountChipHtml(chipClass, removeClass, code) {
    const e = escHtml(code);
    return `<span class="${chipClass}" data-code="${e}">`
      + ICON_CHECK
      + `<span>${e}</span>`
      + `<button type="button" class="${removeClass}" data-discount-remove="${e}" aria-label="Remove ${e}">${ICON_CLOSE}</button>`
      + `</span>`;
  }

  // Paints the drawer discount UI (code chips + savings + struck subtotal) from a
  // cart JSON payload. Called from renderCartDrawerItems so discounts survive
  // every ajax re-render, and from hydrateCart() on first load.
  function renderDrawerDiscount(cart) {
    if (!cart) return;
    const codesEl = $('#cartDrawerDiscountCodes');
    const savingsEl = $('#cartDrawerSavings');
    const savingsValueEl = $('#cartDrawerSavingsValue');
    const subtotalWasEl = $('#cartSubtotalWas');
    const errorEl = $('#cartDrawerDiscountError');
    const codes = applicableCodes(cart);
    const totalDiscount = Number(cart.total_discount) || 0;

    if (codesEl) {
      codesEl.innerHTML = codes
        .map(dc => discountChipHtml('cart-drawer__discount-chip', 'cart-drawer__discount-remove', dc.code))
        .join('');
      if (codes.length && errorEl) errorEl.hidden = true;
    }

    if (savingsEl) savingsEl.hidden = totalDiscount <= 0;
    if (savingsValueEl) savingsValueEl.textContent = '-' + formatMoney(totalDiscount);
    if (subtotalWasEl) {
      subtotalWasEl.hidden = totalDiscount <= 0;
      subtotalWasEl.textContent = formatMoney(cart.original_total_price);
    }
  }

  // Reflect discount codes / savings on the cart page from a cart JSON payload.
  // No-op on any page without the cart template. Patches only what a manual
  // discount code changes: line prices, the savings row, and the subtotal.
  function renderCartPage(cart) {
    const page = $('.cart-page');
    if (!page || !cart || !Array.isArray(cart.items)) return;

    // Cart emptied elsewhere (e.g. the drawer) while the cart page is open: reload
    // so the server renders the empty state rather than leaving stale rows behind.
    if (cart.item_count === 0) { window.location.reload(); return; }

    const totalDiscount = Number(cart.total_discount) || 0;

    cart.items.forEach(item => {
      const row = page.querySelector(`.cart-item[data-key="${item.key}"]`);
      if (!row) return;
      const qtyInput = row.querySelector('[data-qty-input]');
      if (qtyInput) qtyInput.value = item.quantity;
      const priceEl = row.querySelector('.cart-item__price');
      if (!priceEl) return;
      const cell = priceEl.parentElement;
      let wasEl = cell.querySelector('.cart-item__price-was');
      if (item.original_line_price !== item.final_line_price) {
        if (!wasEl) {
          wasEl = document.createElement('div');
          wasEl.className = 'cart-item__price-was';
          cell.insertBefore(wasEl, priceEl);
        }
        wasEl.textContent = formatMoney(item.original_line_price);
        wasEl.hidden = false;
      } else if (wasEl) {
        wasEl.hidden = true;
      }
      priceEl.textContent = formatMoney(item.final_line_price);
    });

    const codesEl = $('#cartSummaryCodes');
    if (codesEl) {
      codesEl.innerHTML = applicableCodes(cart)
        .map(dc => discountChipHtml('cart-summary__code', 'cart-summary__code-remove', dc.code))
        .join('');
    }

    const savingsRow = $('#cartSummarySavings');
    const savingsValue = $('#cartSummarySavingsValue');
    if (savingsRow) savingsRow.hidden = totalDiscount <= 0;
    if (savingsValue) savingsValue.textContent = '-' + formatMoney(totalDiscount);

    const wasTotal = $('#cartSummaryWas');
    const total = $('#cartSummaryTotal');
    if (wasTotal) {
      wasTotal.hidden = totalDiscount <= 0;
      wasTotal.textContent = formatMoney(cart.original_total_price);
    }
    if (total) total.textContent = formatMoney(cart.total_price);

    updateCartPageShippingBar(cart.total_price);
  }

  function updateCartPageShippingBar(total) {
    const bar = $('.cart-page .free-shipping-bar');
    if (!bar) return;
    const threshold = cfg.freeShippingThreshold || 10000;
    const label = bar.querySelector('.free-shipping-bar__label');
    const fill = bar.querySelector('.free-shipping-bar__fill');
    const reached = total >= threshold;
    bar.classList.toggle('free-shipping-bar--reached', reached);
    if (label) {
      label.innerHTML = reached
        ? "You've unlocked free delivery!"
        : `Spend <strong>${formatMoney(threshold - total)}</strong> more for free delivery`;
    }
    if (fill) fill.style.width = Math.min(100, Math.round(total / threshold * 100)) + '%';
  }

  function showDiscountError(errorEl, code) {
    if (!errorEl) return;
    const tpl = cfg.locales?.discountError || '"[[code]]" isn’t a valid discount code';
    errorEl.textContent = tpl.replace('[[code]]', code);
    errorEl.hidden = false;
  }

  // Reflect a fresh cart payload everywhere, in place.
  function syncCartUI(cart) {
    if (!cart) return;
    updateCartBadge(cart.item_count);
    renderCartDrawerItems(cart);
    renderCartPage(cart);
    document.dispatchEvent(new CustomEvent('cart:updated', { detail: cart }));
  }

  // Apply a discount code via the ajax cart API. An inapplicable code still
  // returns HTTP 200 with { applicable: false } in discount_codes.
  function applyDiscount(code, opts) {
    opts = opts || {};
    const { input, errorEl } = opts;
    if (!code) return;
    return fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify({ discount: code })
    })
      .then(r => r.json())
      .then(cart => {
        const hit = (cart.discount_codes || []).find(
          d => d && String(d.code).toLowerCase() === code.toLowerCase());
        if (!hit || !hit.applicable) {
          showDiscountError(errorEl, code);
          return;
        }
        if (errorEl) errorEl.hidden = true;
        if (input) input.value = '';
        syncCartUI(cart);
      })
      .catch(() => showDiscountError(errorEl, code));
  }

  // Clears every applied code ({ discount: '' } removes all of them); the
  // theme's discount UI is single-code so per-code removal isn't needed.
  function removeDiscount() {
    return fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify({ discount: '' })
    })
      .then(r => r.json())
      .then(syncCartUI)
      .catch(() => {});
  }

  // Cart-page section id, resolved from the DOM so it survives a section rename.
  // For the JSON cart template (templates/cart.json) this is "main".
  function cartPageSectionId() {
    const wrap = $('.cart-page')?.closest('.shopify-section');
    return wrap ? wrap.id.replace(/^shopify-section-/, '') : null;
  }

  // Line item keys aren't persistent — they change when discounts reallocate on a
  // quantity change — so the cart page can't be reconciled in JS by key. Let Liquid
  // re-render the whole section and swap it in.
  function swapCartPageSection(id, html) {
    const wrap = document.getElementById('shopify-section-' + id);
    const fresh = html
      ? new DOMParser().parseFromString(html, 'text/html').getElementById('shopify-section-' + id)
      : null;
    if (!wrap || !fresh) { window.location.reload(); return; }
    wrap.replaceWith(fresh);
  }

  function cartUpdate(key, quantity, opts) {
    opts = opts || {};
    const sectionId = opts.rerenderCartPage ? cartPageSectionId() : null;
    const payload = { id: key, quantity };
    if (sectionId) {
      payload.sections = sectionId;
      payload.sections_url = '/cart';
    }
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify(payload)
    })
      .then(r => r.json().then(body => ({ ok: r.ok, body })))
      .then(({ ok, body }) => {
        if (!ok) {
          const msg = (body && (body.description || body.message)) || cfg.locales?.cartError;
          return refreshCartDrawer().then(() => showLineError(key, msg));
        }
        clearLineErrors();
        updateCartBadge(body.item_count);
        renderCartDrawerItems(body);
        if (sectionId) {
          swapCartPageSection(sectionId, body.sections && body.sections[sectionId]);
          // The re-rendered section is built from the Liquid `cart`, which has no
          // manual discount codes — re-hydrate the summary (code pills, savings,
          // struck subtotal) from the ajax payload, exactly like first paint.
          if (body.item_count > 0) renderCartPage(body);
        } else {
          renderCartPage(body);
        }
        document.dispatchEvent(new CustomEvent('cart:updated', { detail: body }));
      })
      .catch(() => refreshCartDrawer().then(() => showLineError(key, cfg.locales?.cartError)));
  }

  function addToCart(variantId, quantity, el) {
    if (!variantId) return;
    const originalText = el?.innerHTML;
    if (el) {
      el.disabled = true;
      el.innerHTML = (cfg.locales?.cartAdding || 'Adding…');
    }

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify({ id: parseInt(variantId), quantity: quantity || 1 })
    })
      .then(r => {
        if (!r.ok) throw new Error('Cart error');
        return r.json();
      })
      .then(() => {
        if (el) {
          el.disabled = false;
          el.innerHTML = (cfg.locales?.cartAdded || 'Added!');
          setTimeout(() => { el.innerHTML = originalText; }, 2000);
        }
        refreshCartDrawer();
        if (cfg.cartType === 'drawer') openCartDrawer();
        document.dispatchEvent(new CustomEvent('cart:item-added'));
      })
      .catch(() => {
        if (el) {
          el.disabled = false;
          el.innerHTML = originalText;
        }
      });
  }

  function openCartDrawer() {
    const drawer = $('#cartDrawer');
    const overlay = $('#cartDrawerOverlay');
    const toggle = $('#cartToggle');
    if (!drawer) return;
    drawer.classList.add('open');
    overlay.classList.add('open');
    document.body.style.overflow = 'hidden';
    drawer.setAttribute('aria-hidden', 'false');
    if (toggle) toggle.setAttribute('aria-expanded', 'true');
  }

  function closeCartDrawer() {
    const drawer = $('#cartDrawer');
    const overlay = $('#cartDrawerOverlay');
    const toggle = $('#cartToggle');
    if (!drawer) return;
    drawer.classList.remove('open');
    overlay.classList.remove('open');
    document.body.style.overflow = '';
    drawer.setAttribute('aria-hidden', 'true');
    if (toggle) toggle.setAttribute('aria-expanded', 'false');
  }

  function initCart() {

    hydrateCart();

    on($('#cartToggle'), 'click', openCartDrawer);
    on($('#cartDrawerClose'), 'click', closeCartDrawer);
    on($('#cartDrawerOverlay'), 'click', closeCartDrawer);

    on(document, 'click', e => {
      const btn = e.target.closest('[data-add-to-cart]');
      if (!btn) return;
      e.preventDefault();
      const variantId = btn.dataset.variantId;
      const qtyInput = btn.closest('form')?.querySelector('[name="quantity"]');
      const qty = parseInt(qtyInput?.value || 1);
      addToCart(variantId, qty, btn);
    });

    on(document, 'submit', e => {
      const form = e.target.closest('form[id^="product-form"]');
      if (!form) return;
      e.preventDefault();
      const variantSelect = form.querySelector('[name="id"]');
      const qtyInput = form.querySelector('[name="quantity"]');
      const btn = form.querySelector('[data-add-to-cart-btn]');
      if (!variantSelect) return;
      addToCart(variantSelect.value, parseInt(qtyInput?.value || 1), btn);
    });

    on($('#cartDiscountApply'), 'click', () => {
      const input = $('#cartDiscountCode');
      applyDiscount(input?.value?.trim(), { input, errorEl: $('#cartDrawerDiscountError') });
    });

    // Delegated (not bound directly to #ApplyDiscount) so it keeps working after a
    // cart-page section swap on a quantity/remove update.
    on(document, 'click', e => {
      if (!e.target.closest('#ApplyDiscount')) return;
      const input = $('#DiscountCode');
      applyDiscount(input?.value?.trim(), { input, errorEl: $('#DiscountError') });
    });

    on(document, 'click', e => {
      const btn = e.target.closest('[data-discount-remove]');
      if (!btn) return;
      e.preventDefault();
      removeDiscount();
    });

    on(document, 'click', e => {
      const btn = e.target.closest('[data-remove-key]');
      if (!btn) return;
      const fromCartPage = !!btn.closest('.cart-page');
      if (!fromCartPage && !btn.closest('.cart-drawer')) return;
      e.preventDefault();
      cartUpdate(btn.dataset.removeKey, 0, { rerenderCartPage: fromCartPage });
    });

    on(document, 'click', e => {
      const qbtn = e.target.closest('.cart-drawer [data-cart-qty-btn]');
      if (!qbtn) return;
      const key = qbtn.dataset.key;
      const input = $(`[data-cart-qty-input][data-key="${key}"]`);
      const delta = parseInt(qbtn.dataset.cartQtyBtn, 10);
      const newQty = Math.max(0, parseInt(input?.value || '1', 10) + delta);
      cartUpdate(key, newQty);
    });

    on(document, 'change', e => {
      const input = e.target.closest('.cart-drawer [data-cart-qty-input]');
      if (!input) return;
      const newQty = Math.max(0, parseInt(input.value || '1', 10));
      cartUpdate(input.dataset.key, newQty);
    });

    // Full cart page quantity widget (snippets/quantity-input.liquid): the +/-
    // buttons (via adjustQty) and direct typing both dispatch a bubbling `change`.
    // Persist via a server-side section re-render — line item keys churn when
    // discounts reallocate, so the page can't be reconciled in JS by key.
    on(document, 'change', e => {
      const input = e.target.closest('.cart-page [data-qty-input]');
      if (!input) return;
      const row = input.closest('.cart-item[data-key]');
      if (!row) return;
      const newQty = Math.max(0, parseInt(input.value || '1', 10));
      cartUpdate(row.dataset.key, newQty, { rerenderCartPage: true });
    });
  }

  function adjustQty(btn, delta) {
    const wrap = btn.closest('[data-qty-wrap]');
    if (!wrap) return;
    const input = wrap.querySelector('[data-qty-input]');
    if (!input) return;
    const min = parseInt(input.min) || 1;
    const newVal = Math.max(min, parseInt(input.value) + delta);
    input.value = newVal;
    input.dispatchEvent(new Event('change', { bubbles: true }));
  }

  window.adjustQty = adjustQty;

  function initProductGallery() {
    const thumbs  = $$('.thumb');
    const mainImg = $('#mainImgEl');
    const track   = $('#thumbsTrack');
    const prevBtn = $('#thumbsPrev');
    const nextBtn = $('#thumbsNext');
    if (!thumbs.length || !mainImg) return;

    function updateArrows() {
      if (!track || !prevBtn || !nextBtn) return;
      const atStart = track.scrollLeft <= 4;
      const atEnd   = track.scrollLeft + track.clientWidth >= track.scrollWidth - 4;
      prevBtn.classList.toggle('thumbs-arrow--disabled', atStart);
      nextBtn.classList.toggle('thumbs-arrow--disabled', atEnd);
    }

    if (track) {
      on(track, 'scroll', updateArrows, { passive: true });
      requestAnimationFrame(updateArrows);
      const thumbW = () => (track.querySelector('.thumb')?.offsetWidth || 80) + 8;
      on(prevBtn, 'click', () => track.scrollBy({ left: -thumbW() * 2, behavior: 'smooth' }));
      on(nextBtn, 'click', () => track.scrollBy({ left:  thumbW() * 2, behavior: 'smooth' }));
    }

    thumbs.forEach(thumb => {
      on(thumb, 'click', () => {
        const src = thumb.dataset.thumbSrc;
        if (!src) return;
        mainImg.style.opacity = '0';
        mainImg.src = src;
        mainImg.decode()
          .then(() => { mainImg.style.opacity = '1'; })
          .catch(() => { mainImg.style.opacity = '1'; });
        thumbs.forEach(t => t.classList.remove('active'));
        thumb.classList.add('active');
      });
    });

    const srcs = thumbs.map(t => t.dataset.thumbSrc).filter(Boolean);
    if (srcs.length > 1) {
      const preload = () => srcs.forEach(src => { new Image().src = src; });
      if ('requestIdleCallback' in window) {
        requestIdleCallback(preload, { timeout: 2000 });
      } else {
        setTimeout(preload, 600);
      }
    }
  }

  function initVariantPicker() {
    $$('variant-picker').forEach(vp => {
      const section = vp.dataset.section;
      const hiddenSelect = vp.querySelector(`#ProductSelect-${section}`);
      if (!hiddenSelect) return;

      on(vp, 'click', e => {
        const pill = e.target.closest('.opt-pill, .pc-swatch');
        if (!pill) return;

        const optGroup = pill.closest('[data-option-index]');
        if (!optGroup) return;
        const optIndex = parseInt(optGroup.dataset.optionIndex);

        $$('.opt-pill, .pc-swatch', optGroup).forEach(p => p.classList.remove('selected', 'active'));
        pill.classList.add('selected', 'active');

        const labelValue = optGroup.querySelector('[data-option-value]');
        if (labelValue) labelValue.textContent = pill.dataset.value;

        updateVariantFromSelections(vp, hiddenSelect, section);
      });

      $$('select.opt-sel', vp).forEach(sel => {
        on(sel, 'change', () => updateVariantFromSelections(vp, hiddenSelect, section));
      });
    });
  }

  function updateVariantFromSelections(vp, hiddenSelect, sectionId) {
    const options = $$('[data-option-index]', vp).map(group => {
      const pill = group.querySelector('.opt-pill.selected, .pc-swatch.active');
      const sel = group.querySelector('select.opt-sel');
      if (pill) return pill.dataset.value;
      if (sel) return sel.value;
      return null;
    }).filter(Boolean);

    const opts = hiddenSelect.options;
    for (let i = 0; i < opts.length; i++) {
      const opt = opts[i];
      // Match on per-option data attributes, not the title — option values can themselves contain " / "
      const variantOptions = [opt.dataset.option1, opt.dataset.option2, opt.dataset.option3];
      const matches = options.every((v, idx) => variantOptions[idx] === v);
      if (matches) {
        hiddenSelect.value = opt.value;
        onVariantChange(opt, sectionId);
        break;
      }
    }
  }

  function onVariantChange(opt, sectionId) {
    const variantId = opt.value;
    const price = parseInt(opt.dataset.price) || 0;
    const compareAt = parseInt(opt.dataset.compareAt) || 0;
    const available = opt.dataset.available === 'true';
    const image = opt.dataset.image;

    const priceEl = $('#productPrice');
    if (priceEl && price) {
      let html = '';
      if (compareAt > price) {
        html = `<span class="price__was">${formatMoney(compareAt)}</span><span class="price__regular price__sale">${formatMoney(price)}</span>`;
      } else {
        html = `<span class="price__regular">${formatMoney(price)}</span>`;
      }
      priceEl.innerHTML = html;
    }

    const atcBtn = $('#AddToCart');
    const atcText = $('#AddToCartText');
    if (atcBtn) {
      atcBtn.disabled = !available;
      if (atcText) atcText.textContent = available ? (cfg.locales?.cartAdd || 'Add to Cart') : 'Sold Out';
      if (variantId) atcBtn.dataset.variantId = variantId;
    }

    const stickyPrice = $('#stickyAtcPrice');
    const stickyBtn = $('.sticky-atc__btn');
    if (stickyPrice) stickyPrice.textContent = formatMoney(price);
    if (stickyBtn && variantId) stickyBtn.dataset.variantId = variantId;

    if (image) {
      const mainImg = $('#mainImgEl');
      if (mainImg) mainImg.src = image;
    }

    if (variantId) {
      const url = new URL(window.location);
      url.searchParams.set('variant', variantId);
      window.history.replaceState({}, '', url);
    }

    const availEl = $('#productAvailability');
    if (availEl) {
      availEl.className = available ? 'in-stock' : 'out-of-stock';
      availEl.textContent = available ? 'In Stock' : 'Out of Stock';
    }

    const bisForm = $('#backInStockForm');
    if (bisForm) bisForm.style.display = available ? 'none' : 'block';
  }

  function initReviewStarsLink() {
    $$('.pc-stars--link').forEach((link) => {
      on(link, 'click', (e) => {
        const target = $('[data-block-handle="review_widget"]') || $('#reviews');
        if (!target) return; // no widget on page -> let href="#reviews" handle it
        e.preventDefault();
        target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
    });
  }

  function initProductAccordion() {
    function closeItem(item) {
      const answer = item.querySelector('.prod-accordion-answer');
      const btn = item.querySelector('.prod-accordion-question');
      item.classList.remove('is-open');
      btn.setAttribute('aria-expanded', 'false');
      answer.style.height = '0';
    }

    function openItem(item) {
      const answer = item.querySelector('.prod-accordion-answer');
      const inner = answer.querySelector('.prod-accordion-answer__inner');
      const btn = item.querySelector('.prod-accordion-question');
      item.classList.add('is-open');
      btn.setAttribute('aria-expanded', 'true');
      answer.style.height = inner.offsetHeight + 'px';
    }

    $$('.prod-accordion-item.is-open').forEach(item => {
      const answer = item.querySelector('.prod-accordion-answer');
      const inner = answer.querySelector('.prod-accordion-answer__inner');
      answer.style.height = inner.offsetHeight + 'px';
    });

    on(document, 'click', e => {
      const btn = e.target.closest('.prod-accordion-question');
      if (!btn) return;
      const item = btn.closest('.prod-accordion-item');
      const container = btn.closest('.prod-accordion');
      if (!item || !container) return;
      const isOpen = item.classList.contains('is-open');

      $$('.prod-accordion-item.is-open', container).forEach(sibling => {
        if (sibling !== item) closeItem(sibling);
      });

      if (isOpen) {
        closeItem(item);
      } else {
        openItem(item);
      }
    });
  }

  function initStickyAtc() {
    const atcBtn = $('#AddToCart');
    const stickyBar = $('#stickyAtc');
    if (!atcBtn || !stickyBar) return;

    const observer = new IntersectionObserver(entries => {
      stickyBar.classList.toggle('is-visible', !entries[0].isIntersecting);
    }, { threshold: 0 });

    observer.observe(atcBtn);
  }

  function initQuickView() {
    const modal = $('#quickViewModal');
    const content = $('#quickViewContent');
    if (!modal) return;

    on(document, 'click', e => {
      const btn = e.target.closest('[data-quick-view]');
      if (!btn) return;
      e.preventDefault();
      openQuickView(btn.dataset.quickView);
    });

    on(modal, 'click', e => {
      if (e.target === modal) closeQuickView();
    });

    on(document, 'keydown', e => {
      if (e.key === 'Escape') closeQuickView();
    });

    function openQuickView(handle) {
      if (!content) return;
      content.innerHTML = '<div style="padding:60px;text-align:center;"><div class="spinner spinner--lg"></div></div>';
      modal.classList.add('open');
      modal.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';

      fetch(`/products/${handle}.js`)
        .then(r => r.json())
        .then(product => {
          const variant = product.variants[0];
          const img = product.images[0] ? product.images[0].src + '&width=800' : '';
          content.innerHTML = `
            <button class="modal__close" type="button" data-close-modal>×</button>
            <div class="quick-view__grid">
              <div class="quick-view__images">
                <img class="quick-view__main-img" src="${img}" alt="${product.title}">
              </div>
              <div class="quick-view__info">
                <div class="quick-view__vendor">${product.vendor}</div>
                <h2 class="quick-view__title">${product.title}</h2>
                <div class="quick-view__price">${formatMoney(variant.price)}</div>
                <div class="quick-view__atc">
                  <button class="btn-atc" type="button" data-variant-id="${variant.id}" data-add-to-cart>
                    Add to Cart
                  </button>
                </div>
                <a class="quick-view__view-full" href="/products/${handle}">View full details →</a>
              </div>
            </div>`;

          on($('[data-close-modal]', content), 'click', closeQuickView);
        })
        .catch(() => {
          content.innerHTML = '<p style="padding:40px;text-align:center;color:var(--text-mid);">Could not load product.</p>';
        });
    }

    function closeQuickView() {
      modal.classList.remove('open');
      modal.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
    }
  }

  function initModals() {
    on(document, 'click', e => {
      const opener = e.target.closest('[data-open-modal]');
      if (opener) {
        const modal = $(`#${opener.dataset.openModal}`);
        if (modal) {
          modal.classList.add('open');
          modal.setAttribute('aria-hidden', 'false');
          document.body.style.overflow = 'hidden';
        }
        return;
      }
      const closer = e.target.closest('[data-close-modal]');
      if (closer) {
        const modalId = typeof closer.dataset.closeModal === 'string' && closer.dataset.closeModal;
        const modal = modalId ? $(`#${modalId}`) : closer.closest('.modal-overlay');
        if (modal) {
          modal.classList.remove('open');
          modal.setAttribute('aria-hidden', 'true');
          document.body.style.overflow = '';
        }
        return;
      }
      
      if (e.target.classList.contains('modal-overlay') && !e.target.id.includes('quickView')) {
        e.target.classList.remove('open');
        e.target.setAttribute('aria-hidden', 'true');
        document.body.style.overflow = '';
      }
    });
  }

  function initFaq() {
    on(document, 'click', e => {
      const btn = e.target.closest('.faq-question');
      if (!btn) return;
      const item = btn.closest('.faq-item');
      const answer = item.querySelector('.faq-answer');
      const inner = answer.querySelector('.faq-answer__inner');
      const isOpen = item.classList.contains('is-open');

      if (!isOpen) {
        item.classList.add('is-open');
        btn.setAttribute('aria-expanded', 'true');
        answer.style.height = inner.offsetHeight + 'px';
      } else {
        item.classList.remove('is-open');
        btn.setAttribute('aria-expanded', 'false');
        answer.style.height = '0';
      }
    });
  }

  function initCountdown() {
    const timer = $('#countdownTimer');
    if (!timer) return;
    const endDate = new Date(timer.dataset.end);
    if (isNaN(endDate)) return;

    function tick() {
      const diff = endDate - new Date();
      if (diff <= 0) {
        timer.innerHTML = '<span class="countdown-expired">Sale has ended</span>';
        return;
      }
      const days    = Math.floor(diff / 86400000);
      const hours   = Math.floor((diff % 86400000) / 3600000);
      const minutes = Math.floor((diff % 3600000) / 60000);
      const seconds = Math.floor((diff % 60000) / 1000);

      const pad = n => String(n).padStart(2, '0');
      const set = (id, v) => { const el = $(`#${id}`); if (el) el.textContent = pad(v); };
      set('cdDays', days);
      set('cdHours', hours);
      set('cdMinutes', minutes);
      set('cdSeconds', seconds);
    }

    tick();
    setInterval(tick, 1000);
  }

  function initBeforeAfter() {
    const slider = $('#beforeAfterSlider');
    if (!slider) return;
    const after = $('#baAfter');
    const handle = $('#baHandle');
    if (!after || !handle) return;

    let dragging = false;

    function setPosition(x) {
      const rect = slider.getBoundingClientRect();
      const pct = Math.max(0, Math.min(100, (x - rect.left) / rect.width * 100));
      handle.style.left = pct + '%';
      after.style.clipPath = `inset(0 0 0 ${pct}%)`;
    }

    on(handle, 'mousedown', e => { dragging = true; e.preventDefault(); });
    on(handle, 'touchstart', e => { dragging = true; }, { passive: true });

    on(document, 'mousemove', e => { if (dragging) setPosition(e.clientX); });
    on(document, 'touchmove', e => { if (dragging) setPosition(e.touches[0].clientX); }, { passive: true });

    on(document, 'mouseup',  () => { dragging = false; });
    on(document, 'touchend', () => { dragging = false; });
  }

  function initCollectionSort() {
    const sortSelect = $('#SortSelect');
    if (!sortSelect) return;
    on(sortSelect, 'change', () => {
      const url = new URL(window.location);
      url.searchParams.set('sort_by', sortSelect.value);
      window.location = url.toString();
    });
  }

  function initProductTrustBadges() {
    const wrap = $('#prodTrustBadges');
    if (!wrap) return;
    const track = wrap.querySelector('.pt-track');
    if (!track) return;
    const origItems = $$('.pt-item', track);
    if (origItems.length <= 1) return;

    const origCount = origItems.length;
    let current = 0;
    let timer = null;

    const dotsWrap = document.createElement('div');
    dotsWrap.className = 'pt-dots';
    origItems.forEach((_, i) => {
      const dot = document.createElement('button');
      dot.type = 'button';
      dot.className = 'pt-dot' + (i === 0 ? ' on' : '');
      dot.setAttribute('aria-label', `Go to trust badge ${i + 1}`);
      on(dot, 'click', () => { goTo(i, true); restart(); });
      dotsWrap.appendChild(dot);
    });
    wrap.appendChild(dotsWrap);
    const dotEls = $$('.pt-dot', dotsWrap);

    function goTo(index, animate) {
      current = index;
      track.style.transition = animate ? 'transform 0.55s cubic-bezier(.22,.1,.25,1)' : 'none';
      track.style.transform = `translateX(-${100 * index}%)`;
      dotEls.forEach((d, i) => d.classList.toggle('on', i === index));
    }

    function restart() {
      if (timer) clearInterval(timer);
      timer = setInterval(() => {
        goTo((current + 1) % origCount, true);
      }, 4000);
    }

    goTo(0, false);
    restart();

    on(wrap, 'mouseenter', () => { if (timer) clearInterval(timer); });
    on(wrap, 'mouseleave', restart);
  }

  function initCardSwatches() {
    on(document, 'click', e => {
      const swatch = e.target.closest('.pc-swatch');
      if (!swatch) return;
      const card = swatch.closest('.product-card');
      if (!card) return;

      $$('.pc-swatch', card).forEach(s => s.classList.remove('active'));
      swatch.classList.add('active');

      const variantId = swatch.dataset.variantId;
      const imgSrc    = swatch.dataset.image;

      if (imgSrc) {
        const img = card.querySelector('[data-product-img]');
        if (img) {
          img.style.opacity = '0';
          img.src = imgSrc;
          img.decode()
            .then(() => { img.style.opacity = '1'; })
            .catch(() => { img.style.opacity = '1'; });
        }
      }

      if (variantId) {
        [card.querySelector('.pc-img'), card.querySelector('.pc-name a')].forEach(link => {
          if (!link) return;
          try {
            const url = new URL(link.href);
            url.searchParams.set('variant', variantId);
            link.href = url.toString();
          } catch (_) {}
        });

        const atcBtn = card.querySelector('[data-add-to-cart]');
        if (atcBtn) atcBtn.dataset.variantId = variantId;
      }
    });
  }

  function initFilterDrawer() {
    const drawer   = $('#filterDrawer');
    const overlay  = $('#filterDrawerOverlay');
    const toggle   = $('#filterToggle');
    const closeBtn = $('#filterDrawerClose');
    if (!drawer) return;

    const desktopMQ = window.matchMedia('(min-width: 901px)');

    function syncDrawerA11y() {
      if (desktopMQ.matches) {
        drawer.removeAttribute('role');
        drawer.removeAttribute('aria-modal');
        drawer.setAttribute('aria-hidden', 'false');
        document.body.style.overflow = '';
      } else {
        drawer.setAttribute('role', 'dialog');
        drawer.setAttribute('aria-modal', 'true');
        drawer.setAttribute('aria-hidden', drawer.classList.contains('open') ? 'false' : 'true');
      }
    }
    syncDrawerA11y();
    on(desktopMQ, 'change', syncDrawerA11y);

    function openFilterDrawer() {
      drawer.classList.add('open');
      overlay.classList.add('open');
      if (!desktopMQ.matches) {
        document.body.style.overflow = 'hidden';
        drawer.setAttribute('aria-hidden', 'false');
      }
      if (toggle) toggle.setAttribute('aria-expanded', 'true');
    }

    function closeFilterDrawer() {
      drawer.classList.remove('open');
      overlay.classList.remove('open');
      if (!desktopMQ.matches) {
        document.body.style.overflow = '';
        drawer.setAttribute('aria-hidden', 'true');
      } else {
        drawer.setAttribute('aria-hidden', 'false');
      }
      if (toggle) toggle.setAttribute('aria-expanded', 'false');
    }

    on(toggle,   'click', openFilterDrawer);
    on(closeBtn, 'click', closeFilterDrawer);
    on(overlay,  'click', closeFilterDrawer);
    on(document, 'keydown', e => {
      if (e.key === 'Escape' && drawer.classList.contains('open')) closeFilterDrawer();
    });

    $$('.filter-group__toggle').forEach(btn => {
      const body = $('#' + btn.getAttribute('aria-controls'));
      if (!body) return;
      if (btn.getAttribute('aria-expanded') === 'false') {
        body.style.height = '0';
      } else {
        body.style.height = body.scrollHeight + 'px';
      }

      on(btn, 'click', () => {
        const isOpen = btn.getAttribute('aria-expanded') === 'true';
        if (isOpen) {
          body.style.height = body.scrollHeight + 'px';
          body.offsetHeight;
          body.style.height = '0';
          btn.setAttribute('aria-expanded', 'false');
        } else {
          body.style.height = body.scrollHeight + 'px';
          btn.setAttribute('aria-expanded', 'true');
          body.addEventListener('transitionend', () => {
            if (btn.getAttribute('aria-expanded') === 'true') body.style.height = 'auto';
          }, { once: true });
        }
      });
    });

    $$('.filter-group__show-more').forEach(btn => {
      const list = btn.previousElementSibling;
      const body = btn.closest('.filter-group__body');
      const groupToggle = btn.closest('.filter-group')?.querySelector('.filter-group__toggle');
      if (!list) return;

      on(btn, 'click', () => {
        const expanded = list.classList.toggle('filter-group__list--expanded');
        btn.setAttribute('aria-expanded', expanded ? 'true' : 'false');
        btn.textContent = expanded ? btn.dataset.lessLabel : btn.dataset.moreLabel;

        // the group body carries a fixed inline px height from mount / collapse animation;
        // let it grow or shrink to fit the revealed rows while the group is open
        if (body && (!groupToggle || groupToggle.getAttribute('aria-expanded') === 'true')) {
          body.style.height = 'auto';
        }
      });
    });
  }

  function initVideoSections() {
    $$('.video-cover').forEach(cover => {
      on(cover, 'click', () => {
        const src = cover.dataset.src;
        if (!src) return;
        const wrapper = cover.parentElement;
        let embedUrl = src;
        if (src.includes('youtube.com') || src.includes('youtu.be')) {
          embedUrl = src.replace('watch?v=', 'embed/').replace('youtu.be/', 'www.youtube.com/embed/') + '?autoplay=1&rel=0';
        } else if (src.includes('vimeo.com')) {
          const id = src.split('/').pop();
          embedUrl = `https://player.vimeo.com/video/${id}?autoplay=1`;
        }
        const iframe = document.createElement('iframe');
        iframe.src = embedUrl;
        iframe.setAttribute('frameborder', '0');
        iframe.setAttribute('allowfullscreen', '');
        iframe.allow = 'autoplay; encrypted-media';
        iframe.style.cssText = 'position:absolute;inset:0;width:100%;height:100%;';
        wrapper.style.position = 'relative';
        cover.remove();
        wrapper.appendChild(iframe);
      });
    });
  }

  function initRelatedProducts() {
    const section = $('#relatedProducts');
    if (!section) return;

    const productId = section.dataset.productId;
    const limit     = section.dataset.limit || 4;
    const grid      = section.querySelector('.products-grid');
    if (!productId || !grid) return;

    fetch(`/recommendations/products?section_id=product-recommendations&product_id=${productId}&limit=${limit}&intent=related`)
      .then(r => r.text())
      .then(text => {
        const doc  = new DOMParser().parseFromString(text, 'text/html');
        const recs = doc.querySelector('.product-recommendations');
        if (!recs || recs.childElementCount === 0) return;
        grid.innerHTML = recs.innerHTML;
        section.style.display = '';
      })
      .catch(() => {});
  }

  function initRecentlyViewed() {
    const container = $('#recentlyViewed');
    const grid = $('#recentlyViewedGrid');
    if (!grid) return;

    const currentId = parseInt(container?.dataset.current) || 0;

    if (window.location.pathname.includes('/products/')) {
      const handle = window.location.pathname.split('/products/')[1]?.split('?')[0];
      if (handle) {
        let viewed = JSON.parse(localStorage.getItem('rv_products') || '[]');
        viewed = [handle, ...viewed.filter(h => h !== handle)].slice(0, 8);
        localStorage.setItem('rv_products', JSON.stringify(viewed));
      }
    }

    let handles = JSON.parse(localStorage.getItem('rv_products') || '[]')
      .filter((_, i) => i > 0) 
      .slice(0, 4);

    if (handles.length === 0 || !container) return;

    let loaded = 0;
    handles.forEach(handle => {
      fetch(`/products/${handle}.js`)
        .then(r => r.json())
        .then(product => {
          const variant = product.variants[0];
          const img = product.images[0] ? product.images[0] + '&width=600' : '';
          const card = document.createElement('div');
          card.className = 'product-card';
          card.innerHTML = `
            <a class="pc-img" href="/products/${product.handle}">
              ${img ? `<img src="${img}" alt="${product.title}" loading="lazy">` : '<div class="pc-img-ph"></div>'}
            </a>
            <div class="pc-body">
              <p class="pc-brand">${product.vendor}</p>
              <h3 class="pc-name"><a href="/products/${product.handle}">${product.title}</a></h3>
              <div class="pc-foot">
                <div class="pc-price">${formatMoney(variant.price)}</div>
                ${variant.available ? `<button class="btn-cart" data-variant-id="${variant.id}" data-add-to-cart>Add to Cart</button>` : '<span class="btn-cart" style="opacity:.5">Sold Out</span>'}
              </div>
            </div>`;
          grid.appendChild(card);
          loaded++;
          if (loaded >= 1) container.style.display = 'block';
        })
        .catch(() => {});
    });
  }

  function initScrollAnimations() {
    const observer = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.1, rootMargin: '0px 0px -50px 0px' });

    $$('.fade-up').forEach(el => observer.observe(el));
  }

  function initCopyLink() {
    on(document, 'click', e => {
      const btn = e.target.closest('[data-copy-link]');
      if (!btn) return;
      const url = btn.dataset.copyLink;
      const span = btn.querySelector('span');
      navigator.clipboard.writeText(url).then(() => {
        if (span) {
          const orig = span.textContent;
          span.textContent = cfg.locales?.linkCopied || 'Copied!';
          setTimeout(() => { span.textContent = orig; }, 2000);
        }
      });
    });
  }

  function initCookieBanner() {
    const banner = $('#cookieBanner');
    if (!banner) return;
    if (localStorage.getItem('cookie_consent')) return;
    banner.classList.add('is-visible');

    on($('#cookieAccept'), 'click', () => {
      localStorage.setItem('cookie_consent', 'accepted');
      banner.classList.remove('is-visible');
    });

    on($('#cookieDecline'), 'click', () => {
      localStorage.setItem('cookie_consent', 'declined');
      banner.classList.remove('is-visible');
    });
  }

  function initBackInStock() {
    on($('#bisSubmit'), 'click', () => {
      const email = $('#bisEmail')?.value?.trim();
      if (!email) return;
      const btn = $('#bisSubmit');
      const success = $('#bisSuccess');
      if (btn) btn.disabled = true;
      
      if (success) success.style.display = 'block';
    });
  }

  function initPopups() {
    const wrap = $('.popups');
    if (!wrap) return;

    const popups = $$('.popup-overlay', wrap);
    if (!popups.length) return;

    const design = !!(window.Shopify && window.Shopify.designMode);
    const timers = [];
    let lastFocused = null;
    let openEl = null;

    function readStore(key) {
      try { return localStorage.getItem(key); } catch (e) { return null; }
    }
    function writeStore(key, val) {
      try { localStorage.setItem(key, val); } catch (e) { /* private mode — ignore */ }
    }

    function isEligible(el) {
      if (design) return false;
      if (el.dataset.eligible !== 'true') return false;
      const stored = readStore(el.dataset.popupKey);
      if (!stored) return true;
      if (el.dataset.frequency === 'once') return false;
      const ms = parseInt(el.dataset.intervalMs, 10) || 0;
      return (Date.now() - Number(stored)) > ms;
    }

    function otherOverlayOpen() {
      return document.querySelector(
        '.popup-overlay.open, .modal-overlay.open, .cart-drawer.open, .mob-drawer.open'
      );
    }

    function startCountdown(scope) {
      const t = $('[data-countdown]', scope);
      if (!t || t.dataset.running === '1') return;
      const end = new Date(t.dataset.end);
      if (isNaN(end)) return;
      t.dataset.running = '1';

      let id;
      const pad = n => String(n).padStart(2, '0');
      const set = (unit, v) => {
        const s = t.querySelector(`[data-unit="${unit}"]`);
        if (s) s.textContent = pad(v);
      };

      const tick = () => {
        const diff = end - new Date();
        if (diff <= 0) {
          clearInterval(id);
          if (t.dataset.hideExpired === 'true') {
            t.style.display = 'none';
          } else {
            t.innerHTML = '<span class="popup__cd-expired">Offer ended</span>';
          }
          return;
        }
        set('days', Math.floor(diff / 86400000));
        set('hours', Math.floor((diff % 86400000) / 3600000));
        set('minutes', Math.floor((diff % 3600000) / 60000));
        set('seconds', Math.floor((diff % 60000) / 1000));
      };

      tick();
      id = setInterval(tick, 1000);
      timers.push(id);
    }

    function openPopup(el, isPreview) {
      if (openEl && openEl !== el) closePopup(openEl, true);
      openEl = el;
      lastFocused = document.activeElement;
      el.classList.add('open');
      if (isPreview) el.classList.add('popup--editor-preview');
      el.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
      if (!design && !isPreview) writeStore(el.dataset.popupKey, String(Date.now()));
      startCountdown(el);
      const close = $('[data-popup-close]', el);
      if (close && close.focus) close.focus();
    }

    function closePopup(el, silent) {
      el.classList.remove('open', 'popup--editor-preview');
      el.setAttribute('aria-hidden', 'true');
      if (openEl === el) openEl = null;
      if (!otherOverlayOpen()) document.body.style.overflow = '';
      if (!silent && lastFocused && lastFocused.focus) lastFocused.focus();
    }

    on(document, 'click', e => {
      if (e.target.closest('[data-popup-close]')) {
        const el = e.target.closest('.popup-overlay');
        if (el) closePopup(el);
        return;
      }
      if (e.target.classList.contains('popup-overlay')) closePopup(e.target);
    });

    on(document, 'keydown', e => {
      if (e.key === 'Escape' && openEl) closePopup(openEl);
    });

    if (!design) {
      const target = popups.find(isEligible);
      if (target) {
        const delay = (parseInt(target.dataset.delay, 10) || 0) * 1000;
        setTimeout(() => openPopup(target, false), delay);
      }
      return;
    }

    /* --- theme editor: preview the popup whose block is selected --- */
    const resolve = e => e.target.classList && e.target.classList.contains('popup-overlay')
      ? e.target
      : document.getElementById('popup-' + (e.detail && e.detail.blockId));

    document.addEventListener('shopify:block:select', e => {
      const el = resolve(e);
      if (el) openPopup(el, true);
    });
    document.addEventListener('shopify:block:deselect', e => {
      const el = resolve(e);
      if (el) closePopup(el);
    });
    document.addEventListener('shopify:section:unload', () => timers.forEach(clearInterval));
  }

  document.addEventListener('DOMContentLoaded', () => {
    initHeaderScroll();
    initMobileDrawer();
    initMobileSearch();
    initAnnouncementBar();
    initTrustBar();
    initHeroCarousel();
    initBrandsCarousel();
    initBrandSlider();
    initPredictiveSearch();
    initCart();
    initProductGallery();
    initVariantPicker();
    initProductAccordion();
    initReviewStarsLink();
    initStickyAtc();
    initQuickView();
    initModals();
    initFaq();
    initCountdown();
    initBeforeAfter();
    initProductTrustBadges();
    initCardSwatches();
    initCollectionSort();
    initFilterDrawer();
    initVideoSections();
    initRelatedProducts();
    initRecentlyViewed();
    initScrollAnimations();
    initCopyLink();
    initCookieBanner();
    initBackInStock();
    initPopups();
  });

  document.addEventListener('shopify:section:load', e => {
    if (hcInEvent(e)) initHeroCarousel(e.target);
    if (e.target.querySelector('.brand-slider')) initBrandSlider(e.target);
    if (e.target.querySelector && e.target.querySelector('.popups')) initPopups();
  });

  document.addEventListener('shopify:section:unload', e => {
    const s = hcInEvent(e);
    if (s && s._hc) s._hc.stop();
    const bs = e.target.querySelector('.brand-slider');
    if (bs && bs._bs) bs._bs.stop();
  });

  document.addEventListener('shopify:section:select', e => {
    const s = hcInEvent(e);
    if (s && s._hc) s._hc.stop();
  });

  document.addEventListener('shopify:section:deselect', e => {
    const s = hcInEvent(e);
    if (s && s._hc) s._hc.start();
  });

  document.addEventListener('shopify:block:select', e => {
    const slide = document.getElementById('hc-slide-' + (e.detail && e.detail.blockId));
    if (!slide) return;
    const section = slide.closest('.hero-carousel');
    if (section && section._hc) {
      section._hc.stop();
      section._hc.goTo(section._hc.indexOfBlock(e.detail.blockId));
    }
  });

  document.addEventListener('shopify:block:deselect', e => {
    const slide = document.getElementById('hc-slide-' + (e.detail && e.detail.blockId));
    if (!slide) return;
    const section = slide.closest('.hero-carousel');
    if (section && section._hc) section._hc.start();
  });

})();
